import React, { useState, useEffect } from "react";

import { Card } from "@mui/material";

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { loadMembersFromBackendForClient } from "app/services/member.service";
import { checkUserHasMemberRole, readSessionCurrentClient } from "app/services/app.state.service";
import { handleAxiosError } from "app/services/app.error.handler";
import { isEmpty } from "utils/validationUtil";
import { TeamMemberDataGridBase } from "./TeamMemberDataGridBase";
import MemberActivityDataGridView from "../team-activities/MemberActivityDataGridView";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "store/member-slice";

export const TeamMembersMemberView = () => {
    const dispatch = useDispatch();
    const members = useSelector((state) => state.member.rows);
    const [selectedMember, setSelectedMember] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() =>  {
        if(!checkUserHasMemberRole()) return;

        // Get member's user id and get client id associated to that member's user id (from member table)
        var client = readSessionCurrentClient();

        if(isEmpty(client)) return;

        loadMembersFromBackendForClient(client.id)
        .then(response => {
            dispatch(memberActions.replaceData(response.data));
            setIsLoading(false);
        })
        .catch(error=>{
            dispatch(memberActions.replaceData([])); // Set the empty data in activity table
            setIsLoading(false);
            handleAxiosError(error);   
        });
    }, [dispatch]);
  
    if(!checkUserHasMemberRole()) {
        return <div>You do not have access to this functionality.</div>;
    }

    const selectMemberHandler = (memberObj) => {
        setSelectedMember(memberObj);
      }
    
    return (
        <div
            className="data-grid-container"
            style={{ width: '100%', minWidth: 0, padding: '0 16px', boxSizing: 'border-box' }}
        >
            <Card>
                <MDBox
                    mx={2}
                    mt={-3}
                    py={1}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                >
                    <MDTypography variant="h6" color="white">
                        Client Team Members
                    </MDTypography>
                </MDBox>

                <TeamMemberDataGridBase membersData={members} isLoading={isLoading} clickEventHandler={selectMemberHandler} />
            </Card>
            {selectedMember && (
                <div style={{ marginTop: 24 }}>
                    <MemberActivityDataGridView selectedMember={selectedMember}/>
                </div>
            )}
        </div>

    );
};